import React from 'react';
import { gapIsAddressed, gapIsUnderReview } from '~/util';
import { useRoleActions } from '~/util/useRoleActions';

interface AnswerProps {
    answer?: null | boolean | undefined;
    handleInputChange: (e: {
        target: {
            id: string;
            value: boolean;
        };
    }) => void;
    hcc: RiskGapType;
    inline?: boolean;
    disabled?: boolean;
}
export function Answer({
    answer = null,
    handleInputChange,
    hcc,
    inline = false,
    disabled = false,
}: AnswerProps) {
    const rolePermission = useRoleActions('allow_save_edit_answer_risk_gap');
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const val = e.target.value;
        handleInputChange({
            target: {
                id: 'answer',
                value: val === '1',
            },
        });
    }

    const isDisabled =
        !rolePermission || hcc.is_added || disabled || gapIsAddressed(hcc) || gapIsUnderReview(hcc);

    const rolePermissionText = !rolePermission
        ? 'You don’t have permission to save responses on this record.'
        : undefined;

    return (
        <div className="attestation-answer text-center">
            <label className="form-label" title={rolePermissionText}>
                Agree
                {inline || <br />}
                <input
                    type="radio"
                    name={hcc.id + (inline ? '-modal' : '')}
                    value={1}
                    checked={answer === true}
                    disabled={isDisabled}
                    onChange={handleChange}
                    title={rolePermissionText}
                />
            </label>
            {inline || <br />}
            <label className="form-label" title={rolePermissionText}>
                {inline && 'Disagree'}
                <input
                    type="radio"
                    name={hcc.id + (inline ? '-modal' : '')}
                    value={0}
                    checked={answer === false}
                    disabled={isDisabled}
                    onChange={handleChange}
                    title={rolePermissionText}
                />
                {inline || (
                    <>
                        <br />
                        Disagree
                    </>
                )}
            </label>
        </div>
    );
}
